import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

function SvgIconExpandHeaderArrow({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 9"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.62 0L7.202 5.418 1.784 0 0 1.784l7.202 7.203 7.203-7.203z"
      />
    </svg>
  );
}

export default SvgIconExpandHeaderArrow;
